/**
 * Video module
 * @module Video
 * @see module: WTM_Libs
 * @see module: Polyfill
 * @see module: SlidersInit
 * @see module: SlidersFactory
 */
define([
    'wtm_libs',
    'sliders_init',
    'polyfill',
    'sliders_factory'
], (wtm) => {

    if (wtm.debug_mode) console.log('> Video starts');
    if (!document.getElementById(wtm.sliders.video.name)) return;

    let slider = document.getElementById(wtm.sliders.video.name),
        target = slider.getElementsByClassName(wtm.widgets.video.set__iframe_containers_class),
        screen = window.innerWidth,
        stop = false;

    /**
     * Function that checks for DOM element and triggers the chain
     * @return {void}
     */
    function updateView() {
        if (checkVisible(document.getElementById(wtm.sliders.video.name))) {
            checkingSwiper();
        }
    }

    /**
     * Function that checks for swiper to be ready and triggers the chain
     * @return {void}
     */
    function checkingSwiper() {
        if (wtm.swiperObjects[wtm.sliders.video.name]) {
            wtm.swiperObjects[wtm.sliders.video.name].params.onSlideChangeStart = convertToIframe;
            convertToIframe();
        } else {
            setTimeout(checkingSwiper, 1000);
        }
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    var myEfficientFn = debounce(function () {
        checkingSwiper();
    }, 250);

    /**
     * Add event listener on scroll to check if module in viewport
     * @return {void}
     */
    if (document.getElementById(wtm.sliders.video.name)) {
        updateView();
        window.onscroll = updateView;
        window.addEventListener("resize", myEfficientFn);
    }
    /**
     * Cheking if the module in a viewport for tablet/mobile
     * @return {void}
     */
    function checkVisible(elm) {
        if (elm && !stop) {
            var rect = elm.getBoundingClientRect();
            var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
        } else return;
    }

    /**
     * Function to convert target to iframe
     * @return {void}
     */
    function convertToIframe() {
        let visibleSlides = Array.from(slider.querySelectorAll(".swiper-slide-visible:not(.swiper-slide-converted)"));
        visibleSlides.forEach((elem) => {
            elem.classList.add("swiper-slide-converted");
            video(elem.getElementsByClassName(wtm.widgets.video.set__iframe_containers_class)[0]);
        });
        stop = true;
    }

    /**
     * Function to create iframe
     * @return {void}
     */
    function video(target) {
        var iframeCustom = document.createElement("iframe");
        iframeCustom.src = target.getAttribute("data-videourl");
        iframeCustom.setAttribute("allowfullscreen", "true");
        try {
            iframeCustom.classList.add(wtm.widgets.video.set__iframe_class);
        } catch (e) {
            console.log(e);
        }
        target.appendChild(iframeCustom);
        target.classList.add(wtm.widgets.video.set__iframe_container_active_class);
    }

    if (wtm.debug_mode) console.log('> Video loaded');
});